import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import useYupValidationResolver from './useYupValidationResolver';
import { getEmailValidationSchema } from '../helpers/validationSchemaHelper';
import { EMAIL_DEFAULT_VALUES } from '../constants/login';
import { newsletterApi } from '../api/publicPagesApi';
import useGeneral from './useGeneral';
import useTurnstile from './useTurnstile';
import { NEWSLETTER_CONFIRM_PAGE } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

function useStayInformedCard() {
  const { t } = useTranslation();
  const { showToasts } = useGeneral();
  const resolver = useYupValidationResolver(getEmailValidationSchema());
  const { register, handleSubmit, errors, reset } = useForm({ resolver, defaultValues: EMAIL_DEFAULT_VALUES });
  const navigate = useNavigate();

  const { turnstileToken, ensureTurnstileToken, resetTurnstile, turnstileProps } = useTurnstile();

  async function handleSubmitForm(formData) {
    if (!ensureTurnstileToken()) {
      return;
    }

    try {
      await newsletterApi({ ...formData, turnstile_token: turnstileToken });

      toast.success(t('stay.informed.success.message'));
      reset();

      navigate(NEWSLETTER_CONFIRM_PAGE);
    } catch (error) {
      showToasts(error);
      resetTurnstile();
    }
  }

  return {
    register,
    handleSubmit: handleSubmit(handleSubmitForm),
    errors,
    turnstileProps,
  };
}

export default useStayInformedCard;
